import { render } from "./EmptyStateBook.vue?vue&type=template&id=43e18f6c"
import script from "./EmptyStateBook.vue?vue&type=script&lang=js"
export * from "./EmptyStateBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__